import React, { Component } from "react";
import $ from "jquery/dist/jquery.js";

import * as apiConstant from "../api/apiConstant";
import { getVideoThumbFileName } from "../config/utils";
import logApi from "../api/logApi";

/****************************************
    Component for Single Slider
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/
class SingleSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.isPlaying = false;
    this.onErrorImageLoad = this.onErrorImageLoad.bind(this);
    this.showIndicator = this.showIndicator.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    window.playVideo();
    window.articleGallery();
    window.loadFlexSlider();
    setTimeout(this.showIndicator, 800);
  }

  componentWillUnmount() {}

  onErrorImageLoad(key) {
    $("#img_" + key).attr("src", "/assets/images/no_image.png");
  }

  showIndicator() {
    if (
      $(".flex-control-nav") !== undefined &&
      $(".flex-control-nav") !== null
    ) {
      $(".flex-control-nav").css("visibility", "visible");
    }
  }

  render() {
    return (
      <div className="single-item-slide" id="single_slider">
        <div
          className="fslider"
          data-animation="fade"
          data-thumbs="true"
          data-autoplay="3000"
          id="main_slider"
          data-loop="true"
          data-arrows="true"
          data-speed="500"
          data-pause="4000"
        >
          <div className="flexslider" id="flexslider">
            <div className="slider-wrap" id="slideWrap" data-lightbox="gallery">
              {this.props.media.length > 0 &&
                this.props.media.map((media, key) => (
                  <div
                    className="slide"
                    key={key}
                    isvideo={media.format}
                    data-thumb={
                      media.format === 0
                        ? apiConstant.thumbnail(
                            this.props.business,
                            this.props.id,
                            media.name
                          )
                        : "/assets/images/thumb-icon.png"
                    }
                  >
                    {media.format === 0 && (
                      <img
                        src={apiConstant.desktop(
                          this.props.business,
                          this.props.id,
                          media.name
                        )}
                        id={`img_${media.id}`}
                        className="d-block w-100 d-block-img"
                        onError={() => this.onErrorImageLoad(media.id)}
                        alt="photo"
                      />
                    )}
                    {media.format === 1 && (
                      <div>
                        <img
                          src={apiConstant.thumbnail(
                            this.props.business,
                            this.props.id,
                            getVideoThumbFileName(media.name)
                          )}
                          id={`img_${media.id}`}
                          ref="video_img"
                          className="video-img d-block w-100"
                          onError={() => this.onErrorImageLoad(media.id)}
                          alt="video"
                        />
                        {
                          <a
                            href={apiConstant.desktop(
                              this.props.business,
                              this.props.id,
                              media.name
                            )}
                            className="play-video video-icon large"
                            onClick={() =>
                              logApi.log({
                                title: this.props.title,
                                lang: localStorage.getItem("language"),
                                type: "동화상",
                              })
                            }
                          >
                            <i className="fa fa-play" aria-hidden="true"></i>
                          </a>
                        }
                      </div>
                    )}
                    {/* {media.format === 0 && (
                      <a
                        href={apiConstant.desktop(
                          this.props.business,
                          this.props.id,
                          media.name
                        )}
                        data-lightbox="gallery-item"
                        className={
                          "icon d-flex justify-content-center align-items-center image-popup-icon"
                        }
                        // caption = {this.props.title}
                        onClick={() =>
                          logApi.log({
                            title: this.props.title,
                            lang: localStorage.getItem("language"),
                            type: "사진",
                          })
                        }
                      >
                        <span className="icon-expand"></span>
                      </a>
                    )} */}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SingleSlider;
